import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../../Baseurl";
import AdminSidebar from "../../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../../component/AdminComp/AdminTopbar";
import Swal from "sweetalert2";
import ServiceCategoryNavbar from "./ServiceCategoryNavbar";

const ServiceSubSubCategory = () => {
  const [categories, setCategories] = useState([]);
  const [whatWeDoId, setWhatWeDoId] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [subCategoryId, setSubCategoryId] = useState("");
  const [subSubTitles, setSubSubTitles] = useState([""]); // multiple sub-subcategory titles

  useEffect(() => {
    axios
      .get(`${baseurl}getAllServiceCategories`)
      .then((res) => setCategories(res.data.data || []))
      .catch((err) => console.error("Fetch categories error:", err));
  }, []);

  const generateSlug = (text) =>
    text.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9\-]/g, "");

  // Add new sub-subcategory input
  const addSubSubTitleField = () => setSubSubTitles([...subSubTitles, ""]);

  // Remove input
  const removeSubSubTitleField = (index) => {
    const newTitles = [...subSubTitles];
    newTitles.splice(index, 1);
    setSubSubTitles(newTitles);
  };

  // Update input
  const handleSubSubTitleChange = (index, value) => {
    const newTitles = [...subSubTitles];
    newTitles[index] = value;
    setSubSubTitles(newTitles);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!whatWeDoId || !categoryId || !subCategoryId) {
      Swal.fire("Error", "Please select all parent categories", "error");
      return;
    }

    try {
      const promises = subSubTitles
        .filter((t) => t.trim() !== "")
        .map((title) => {
          const payload = {
            service_title: title,
            has_service: false,
            slug: generateSlug(title),
            parent_id: subCategoryId, // sub-subcategory under selected subcategory
          };
          return axios.post(`${baseurl}addServiceCategory`, payload);
        });

      await Promise.all(promises);
      Swal.fire("Success", "All sub-subcategories added!", "success").then(() =>
        window.location.reload()
      );
    } catch (err) {
      console.error("Submit error:", err);
      Swal.fire("Error", "Failed to add sub-subcategories", "error");
    }
  };

  // Filters
  const whatWeDoList = categories.filter((cat) => cat.parent_id === null);
  const categoryList = categories.filter(
    (cat) => cat.parent_id === parseInt(whatWeDoId)
  );
  const subCategoryList = categories.filter(
    (cat) => cat.parent_id === parseInt(categoryId)
  );
  const subSubCategoryList = categories.filter(
    (cat) => cat.parent_id === parseInt(subCategoryId)
  );

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid text-start">
          <ServiceCategoryNavbar />

          <div className="crd1 p-4 shadow-sm rounded bg-white">
            <h4 className="mb-3">Add Multiple Sub-Subcategories</h4>

            <form onSubmit={handleSubmit}>
              {/* What We Do */}
              <div className="mb-3">
                <label className="form-label">What We Do</label>
                <select
                  className="form-select"
                  required
                  value={whatWeDoId}
                  onChange={(e) => {
                    setWhatWeDoId(e.target.value);
                    setCategoryId("");
                    setSubCategoryId("");
                  }}
                >
                  <option value="">-- Select --</option>
                  {whatWeDoList
                    .sort((a, b) =>
                      a.service_title.localeCompare(b.service_title)
                    )
                    .map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.service_title}
                      </option>
                    ))}
                </select>
              </div>

              {/* Show Categories under What We Do */}
              {whatWeDoId && (
                <div className="mb-3">
                  <h6>Categories under selected What We Do:</h6>
                  {categoryList.length > 0 ? (
                    <div className=" card">
                      {categoryList.map((cat) => (
                        <div key={cat.id} className="ftg1">
                          {cat.service_title}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-muted">No categories found.</p>
                  )}
                </div>
              )}

              {/* Category */}
              <div className="mb-3">
                <label className="form-label">Category</label>
                <select
                  className="form-select"
                  required
                  value={categoryId}
                  onChange={(e) => {
                    setCategoryId(e.target.value);
                    setSubCategoryId("");
                  }}
                  disabled={!whatWeDoId}
                >
                  <option value="">-- Select --</option>
                  {categoryList
                    .sort((a, b) =>
                      a.service_title.localeCompare(b.service_title)
                    )
                    .map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.service_title}
                      </option>
                    ))}
                </select>
              </div>

              {/* Show Subcategories under Category */}
              {categoryId && (
                <div className="mb-3">
                  <h6>Subcategories under selected Category:</h6>
                  {subCategoryList.length > 0 ? (
                    <div className=" card">
                      {subCategoryList.map((sub) => (
                        <div key={sub.id} className=" ftg1">
                          {sub.service_title}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-muted">No subcategories found.</p>
                  )}
                </div>
              )}

              {/* Sub Category */}
              <div className="mb-3">
                <label className="form-label">Sub Category</label>
                <select
                  className="form-select"
                  required
                  value={subCategoryId}
                  onChange={(e) => setSubCategoryId(e.target.value)}
                  disabled={!categoryId}
                >
                  <option value="">-- Select --</option>
                  {subCategoryList
                    .sort((a, b) =>
                      a.service_title.localeCompare(b.service_title)
                    )
                    .map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.service_title}
                      </option>
                    ))}
                </select>
              </div>

              {/* Show Sub-Subcategories under Subcategory */}
              {subCategoryId && (
                <div className="mb-3">
                  <h6>Sub-Subcategories under selected Subcategory:</h6>
                  {subSubCategoryList.length > 0 ? (
                    <div className=" card">
                      {subSubCategoryList.map((subsub) => (
                        <div key={subsub.id} className=" ftg1">
                          {subsub.service_title}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-muted">No sub-subcategories found.</p>
                  )}
                </div>
              )}

              {/* Multiple Sub-Subcategory Titles */}
              <label className="form-label">New Sub-Subcategory Titles</label>
              {subSubTitles.map((title, index) => (
                <div className="input-group mb-2" key={index}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={`Sub-Subcategory #${index + 1}`}
                    value={title}
                    required
                    onChange={(e) =>
                      handleSubSubTitleChange(index, e.target.value)
                    }
                  />
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => removeSubSubTitleField(index)}
                  >
                    Remove
                  </button>
                </div>
              ))}

              <div className="mb-3">
                <button
                  type="button"
                  className="btn btn-secondary me-2"
                  onClick={addSubSubTitleField}
                >
                  + Add Another
                </button>
                <button type="submit" className="btn btn-primary">
                  Add All Sub-Subcategories
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceSubSubCategory;
